import classNames from 'clsx'
import { func, node } from 'prop-types'

import { IS_NODE } from 'shared/consts/env'
import noop from 'shared/utils/noop'
import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'

const OffCanvasNewMenuHeader = ({ headerInfo, onMenuClose }) => {
  const classes = classNames('o-OffCanvasNewView__header l-flex u-no-margin', {
    'u-font-weight--normal': true,
  })

  return (
    <h4 className={classes} suppressHydrationWarning id="OffCanvasViewHeader">
      <span
        className="l-flex__primary u-padding-large--left"
        data-clientside-hook="OffCanvasMenu__header-greeting"
        data-cs-mask="true"
      >
        <div className="l-flex">{headerInfo}</div>
      </span>

      <ButtonTransparent
        name="close-navigation"
        {...(IS_NODE ? { href: '#' } : { onClick: onMenuClose })}
        aria-controls="OffCanvasMenu"
        data-clientside-hook="menu-button"
        suppressHydrationWarning
        inline
        alternative
      >
        <IconCross />
        <span className="a-visuallyhidden">Close navigation</span>
      </ButtonTransparent>
    </h4>
  )
}

OffCanvasNewMenuHeader.propTypes = {
  headerInfo: node,
  onMenuClose: func,
  mountPoints: mountPointsType.isRequired,
}

OffCanvasNewMenuHeader.defaultProps = {
  onMenuClose: noop,
}

export default withMountPoints(OffCanvasNewMenuHeader)
